import React from 'react';

const CustomMinimizeIcon = (props) => (
  <img
    src="https://website-production-bot-assets.s3.amazonaws.com/totalbyverizon/images/minimize.svg"
    alt="Minimize Icon"
    width="24"
    height="24"
    style={{
      display: 'inline-block',
      backgroundSize: 'contain',
      backgroundRepeat: 'no-repeat',
    }}
    {...props}
  />
);

export default CustomMinimizeIcon;
